export default __webpack_public_path__ + "static/media/logo-black-img-not-found.31ff94e5.png";